/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.ComponentKeywordsSearch";
        class ComponentKeywordsSearch extends Widgets.ComponentKeywordsBase {
            constructor(core, container, parent) {
                super(core, container, parent);
                this._defaultDateEntry = 'range';
                this._cacheUpdated = () => {
                    if (this._core.OBHelper.KeywordTypesLoaded && this._core.OBHelper.DownloadDocumentTypesLoaded)
                        this._cacheReady = true;
                };
                this._sanityCheckRequest = (request) => {
                    let querySet = (request.hasOwnProperty('QueryName') && request.QueryName && (this._core.OBHelper.CustomQueryNames.indexOf(request.QueryName) > -1)) ? true : false;
                    let docTypesSet = (request.hasOwnProperty('DocTypes') && request.DocTypes) ? true : false;
                    if (!querySet && !docTypesSet)
                        return false;
                    return true;
                };
                this._servicePendingRequest = () => {
                    this._log.info('ComponentKeywordsSearch::_servicePendingRequest');
                    // Nothing to do if nothing pending
                    if (!this._requestPending)
                        return;
                    // Bump pending request to active status
                    this._requestActive = this._requestPending;
                    this._requestPending = null;
                    this._listRoot.innerHTML = '';
                    this._setUserKeywordPrivilege();
                    if (this.ActiveRequest.hasOwnProperty('QueryName') && this.ActiveRequest.QueryName) {
                        this._buildUIForQuery(this._core.OBHelper.CustomQueryMap[this.ActiveRequest.QueryName]);
                        this._setKeyUpHandler();
                    }
                    else {
                        if (this.ActiveRequest.DocTypes.length == 0)
                            this.clearDisplay();
                        else {
                            this._buildUIForDocType(this._mergeDocTypes());
                            this._setKeyUpHandler();
                        }
                    }
                };
                this._setKeyUpHandler = () => {
                    this._log.info('ComponentKeywordsSearch._setKeyUpHandler');
                    if (this.ActiveRequest.KeyUpHandler) {
                        for (let groupId in this._groupMap) {
                            let kwGrpMapper = this._groupMap[groupId];
                            kwGrpMapper.KeyUpHandler = this.ActiveRequest.KeyUpHandler;
                        }
                    }
                };
                this._setUserKeywordPrivilege = () => {
                    this._log.info('ComponentKeywordsSearch::_setUsereywordPrivilege');
                    // Use LEAST permissive option
                    this._userCanAccessRestrictedKeys = false;
                    if (this.ActiveRequest.hasOwnProperty('DocTypes') && this.ActiveRequest.DocTypes) {
                        let restrictedAccess = true;
                        this.ActiveRequest.DocTypes.forEach(dtName => {
                            let dt = this._core.OBHelper.DownloadDocumentTypeMap[dtName];
                            if (dt && dt.hasOwnProperty('Privileges') && (dt.Privileges)) {
                                if (!dt.Privileges.AccessRestrictedKeywords)
                                    restrictedAccess = false;
                            }
                        });
                        this._userCanAccessRestrictedKeys = restrictedAccess;
                    }
                };
                // Merges mutiple doc types into a single pseudo-type in order to gerate a list of common keywords
                this._mergeDocTypes = () => {
                    this._log.info('ComponentKeywordsSearch::_mergeDocTypes');
                    // Need something to return
                    let mergedType = {
                        Id: -1,
                        Name: "Pseudo-Type",
                        TranslatedName: "Pseudo-Type",
                        KeywordRecords: []
                    };
                    if (!this.ActiveRequest.hasOwnProperty('DocTypes') || (this.ActiveRequest.DocTypes == null) || (this.ActiveRequest.DocTypes.length == 0))
                        return mergedType;
                    // Need to filter our doc types to ensure they are genuine and available
                    let filteredDocTypes = [];
                    this.ActiveRequest.DocTypes.forEach(dtName => {
                        if (this._core.OBHelper.DownloadDocumentTypeNames.indexOf(dtName) > -1) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`Adding doc type 'dtName' to filtered list`);
                            }
                            filteredDocTypes.push(dtName);
                        }
                    });
                    if (filteredDocTypes.length == 0)
                        return mergedType;
                    // Initialise on doc number one
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Initialising merged keyword list for doc type '${filteredDocTypes[0]}'.`);
                    }
                    let mergedKeyTypeNames = this._getAllKeyTypesForDocType(this._core.OBHelper.DownloadDocumentTypeMap[filteredDocTypes[0]]);
                    // Merge with the others
                    let i = 1;
                    while (i < filteredDocTypes.length) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`Merging keyword list for doc type '${filteredDocTypes[i]}'.`);
                        }
                        let newKeyTypeNames = this._getAllKeyTypesForDocType(this._core.OBHelper.DownloadDocumentTypeMap[filteredDocTypes[i]]);
                        let combinedNames = [];
                        while (mergedKeyTypeNames.length > 0) {
                            let keyName = mergedKeyTypeNames.shift();
                            if (newKeyTypeNames.indexOf(keyName) > -1)
                                combinedNames.push(keyName);
                        }
                        mergedKeyTypeNames = combinedNames;
                        i++;
                    }
                    // Insert any remaining non-standalone records
                    if (mergedKeyTypeNames.length > 0) {
                        let saRecord = this._createStandaloneRecordType();
                        mergedKeyTypeNames.forEach(ktName => { saRecord.KeywordTypes.push(this._core.OBHelper.KeywordTypeMap[ktName]); });
                        mergedType.KeywordRecords.push(saRecord);
                    }
                    return mergedType;
                };
                this._getAllKeyTypesForDocType = (docType) => {
                    let keyTypes = [];
                    docType.KeywordRecords.forEach(kwrt => {
                        if ((this.ActiveRequest.IncludeGroups.length > 0) && (this.ActiveRequest.IncludeGroups.indexOf(kwrt.Name) == -1))
                            return;
                        if ((this.ActiveRequest.ExcludeGroups.length > 0) && (this.ActiveRequest.ExcludeGroups.indexOf(kwrt.Name) > -1))
                            return;
                        kwrt.KeywordTypes.forEach(kwt => {
                            if ((this.ActiveRequest.IncludeKeywords.length > 0) && (this.ActiveRequest.IncludeKeywords.indexOf(kwt.Name) == -1))
                                return;
                            if ((this.ActiveRequest.ExcludeKeywords.length > 0) && (this.ActiveRequest.ExcludeKeywords.indexOf(kwt.Name) > -1))
                                return;
                            keyTypes.push(kwt.Name);
                        });
                    });
                    return keyTypes;
                };
                this._buildUIForQuery = (query) => {
                    this._log.info('ComponentKeywordsSearch::_buildUIForQuery');
                    this._groupMap = {};
                    // Need a single keyword group, with all the appropriate search keywords
                    let saRecord = this._createStandaloneRecordType();
                    // Date options - unshift into start of array. Note that OBHelper already defaults DateEntry so it will be populated
                    let dateEntry = this._defaultDateEntry;
                    if (query.DateEntry)
                        dateEntry = query.DateEntry;
                    else if (this.ActiveRequest.hasOwnProperty('DateOption') && this.ActiveRequest.DateOption)
                        dateEntry = this.ActiveRequest.DateOption;
                    if (dateEntry == 'single')
                        saRecord.KeywordTypes.unshift(this._core.OBHelper.KeywordTypeMap['>>DateSingle']);
                    else if (dateEntry == 'range') {
                        // Need to unshift in this order to put them at the top and have "To" then "From"
                        saRecord.KeywordTypes.unshift(this._core.OBHelper.KeywordTypeMap['>>DateTo']);
                        saRecord.KeywordTypes.unshift(this._core.OBHelper.KeywordTypeMap['>>DateFrom']);
                    }
                    ;
                    query.KeywordTypes.forEach(kwt => { saRecord.KeywordTypes.push(kwt); });
                    // Set up the interface
                    let id = Widgets.ComponentKeywordsBase.CounterString;
                    let recordWrapper = new WPTNamespace.MetadataEditors.KeywordGroupWrapper(this._core, this._form, this._listRoot, id, saRecord, null, WPTNamespace.MetadataEditors.KeywordEditMode.SEARCH, this._userCanAccessRestrictedKeys, true, this.ActiveRequest.SimpleEditors);
                    this._groupMap[id] = recordWrapper;
                };
                this.clearValues = () => {
                    this._log.info('ComponentKeywordsSearch.clearValues()');
                    this.makeRequest(this.ActiveRequest);
                };
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._core.OBHelper.LoadDownloadDocumentTypes(this._cacheUpdated);
                this._core.OBHelper.LoadCustomQueries(this._cacheUpdated);
            }
            get ActiveRequest() {
                return this._requestActive;
            }
            get FlexTerms() {
                let terms = [];
                for (let groupId in this._groupMap) {
                    terms.push(...this._groupMap[groupId].FlexTerms);
                }
                return terms;
            }
            get FlexSearchDef() {
                let def = { Type: '', Terms: [] };
                if (this.ActiveRequest.hasOwnProperty('QueryName') && this.ActiveRequest.QueryName) {
                    def.Type = 'customquery';
                    def.Terms.push({ Term: '>>customquery', Value: this.ActiveRequest.QueryName });
                }
                else {
                    def.Type = 'bydocumenttype';
                    this.ActiveRequest.DocTypes.forEach(dt => { def.Terms.push({ Term: '>>DocumentType', Value: dt }); });
                }
                def.Terms.push(...this.FlexTerms);
                return def;
            }
            // When we build the UI, we can check the passed for each group/key added to see if it needs to be populated
            _buildUIForDocType(docType) {
                this._log.info('ComponentKeywordsSearch::_buildUIForDocType');
                this._groupMap = {};
                // Copy our record
                let saRecord = this._createStandaloneRecordType();
                // Note that we can only get standalone keyword records at this point.
                let dateOption = this._defaultDateEntry;
                if (this.ActiveRequest.hasOwnProperty('DateOption') && this.ActiveRequest.DateOption)
                    dateOption = this.ActiveRequest.DateOption;
                if (dateOption == 'single')
                    saRecord.KeywordTypes.unshift(this._core.OBHelper.KeywordTypeMap['>>DateSingle']);
                else if (dateOption == 'range') {
                    // Need to unshift in this order to put them at the top and have "To" then "From"
                    saRecord.KeywordTypes.unshift(this._core.OBHelper.KeywordTypeMap['>>DateTo']);
                    saRecord.KeywordTypes.unshift(this._core.OBHelper.KeywordTypeMap['>>DateFrom']);
                }
                ;
                if (docType.hasOwnProperty('KeywordRecords') && (docType.KeywordRecords.length > 0)) {
                    docType.KeywordRecords[0].KeywordTypes.forEach(kwt => { saRecord.KeywordTypes.push(kwt); });
                }
                if (saRecord.KeywordTypes.length > 0) {
                    // Set up the interface
                    let id = Widgets.ComponentKeywordsBase.CounterString;
                    let recordWrapper = new WPTNamespace.MetadataEditors.KeywordGroupWrapper(this._core, this._form, this._listRoot, id, saRecord, null, WPTNamespace.MetadataEditors.KeywordEditMode.SEARCH, this._userCanAccessRestrictedKeys, true, this.ActiveRequest.SimpleEditors);
                    this._groupMap[id] = recordWrapper;
                }
                else if (this.NoKeysToDisplayCallback)
                    this.NoKeysToDisplayCallback();
            }
        }
        Widgets.ComponentKeywordsSearch = ComponentKeywordsSearch;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
